import { queryDataset } from '../../api/search';

// store/modules/search.js
const state = {
  lastSearchResults: null,
  isLoading: false,
};

const mutations = {
  SET_SEARCH_RESULTS(state, results) {
    state.lastSearchResults = results;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  CLEAR_SEARCH(state) {
    state.lastSearchResults = null;
  },
};

const actions = {
  async search({ commit }, searchTerm) {
    commit('SET_LOADING', true);
    try {
      const response = await queryDataset({ q: searchTerm });
      commit('SET_SEARCH_RESULTS', response.data);
      return response.data;
    } catch (error) {
      console.error('Search failed:', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const getters = {
  lastSearchResults: (state) => state.lastSearchResults,
  isLoading: (state) => state.isLoading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
